// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"styles_tableRow__1bTlC"};